import axios from "axios";
import { luxstansaBaseurl } from "./apiconfig";

const getHeaders = (auth, data, token) => {
    const headers = {
        'Content-Type': 'application/json'
    }
    
    // if ( auth  ) {

    //     if ( token ) {
    //         headers['Authorization'] = 'Bearer ' + token;
    //     }else {
    //         const bearerToken = getValue(ACCESS_TOKEN);
            
    //         if ( bearerToken ) {
    //             headers['Authorization'] = 'Bearer ' + bearerToken;
    //         }
    //     }
    // }

    const config = { headers };
    
    if ( data ) {
        config['data'] = data;
    }

    return config;
};

export const getApi = (url, auth=true) => {
    return axios.get(luxstansaBaseurl + url, getHeaders(auth));
};

export const postApi = (url, data, auth=true) => {
    return axios.post(luxstansaBaseurl + url, data, getHeaders(auth));
};

export const putApi = (url, data, auth=true) => {
    return axios.put(luxstansaBaseurl + url, data, getHeaders(auth));
};

export const deleteApi = (url, data, auth=true) => {
    return axios.delete(luxstansaBaseurl + url, getHeaders(auth, data));
};

export const refreshApi = (token) => {
    return axios.get(luxstansaBaseurl + refresh, getHeaders(true, null, token));
};
